import { Instance, types } from 'mobx-state-tree';
import { RTModel } from './RTModel';

export const TutorCallProviderState = RTModel.named('TutorCallProviderState').props({
  provider: types.enumeration(['dailyco', 'jitsi']),
  revision: types.string,
});

export interface ITutorCallProviderState extends Instance<typeof TutorCallProviderState> {}
